var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-row',[_c('d-col',{attrs:{"lg":"8","xl":"9"}},[_c('d-card',{staticClass:"card-small mb-4"},[_c('d-list-group',{attrs:{"flush":""}},[_c('d-list-group-item',{staticClass:"p-3"},[_c('d-row',[_c('d-col',[_c('word-form',{ref:"wordForm"})],1)],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }